export const compProps = {
    databaseId: 35,
    label: 'Calculate Your Mortgage Payments',
    sublabel: "See what your mortgage payment could be with today's rates.",
    submenu: {
        nodes: [
            {
                databaseId: 36,
                label: 'Refinance Calculator',
                src: 'https://www.quickenloans.com/calculators/refinance-calculator',
                testId: 'refinance_calculator_button',
            },
            {
                databaseId: 37,
                label: 'Mortgage Calculator',
                src: 'https://www.quickenloans.com/calculators/mortgage-calculator',
                testId: 'mortgage_calculator_button',
            },
        ],
    },
};

export const testAttributes = {
    BANNER_CONTAINER: 'calculator-cta_banner-container',
    BANNER_HEADLINE: 'calculator-cta_banner-headline',
    BANNER_SUBHEADLINE: 'calculator-cta_banner-subheadline',
    BANNER_DESCRIPTION: 'calculator-cta_banner-description',
    BANNER_LIST: 'calculator-cta_banner-list',
    BANNER_BUTTON: 'calculator-cta_banner-btn-',
};
